import { render, staticRenderFns } from "./SanadeusPage.vue?vue&type=template&id=804cf5e8&scoped=true&"
import script from "./SanadeusPage.vue?vue&type=script&lang=js&"
export * from "./SanadeusPage.vue?vue&type=script&lang=js&"
import style0 from "./SanadeusPage.vue?vue&type=style&index=0&id=804cf5e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804cf5e8",
  null
  
)

export default component.exports